export const environment = {socket_url: process.env.REACT_APP_SOCKET_URL};
